/**
 * @generated SignedSource<<8c91f1d58e37283b0aa51b311ceafc6b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotoView_photo$data = {
  readonly description: string | null | undefined;
  readonly rowId: any;
  readonly storageObject: {
    readonly blurhash: string | null | undefined;
    readonly bucket: string | null | undefined;
    readonly key: string | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly profile: {
      readonly headshot: {
        readonly rowId: any;
      } | null | undefined;
      readonly photos: {
        readonly totalCount: number;
      };
    } | null | undefined;
  } | null | undefined;
  readonly userId: any;
  readonly " $fragmentType": "PhotoView_photo";
};
export type PhotoView_photo$key = {
  readonly " $data"?: PhotoView_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoView_photo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotoView_photo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StorageObject",
      "kind": "LinkedField",
      "name": "storageObject",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blurhash",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bucket",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Photo",
              "kind": "LinkedField",
              "name": "headshot",
              "plural": false,
              "selections": [
                (v0/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PhotoConnection",
              "kind": "LinkedField",
              "name": "photos",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalCount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Photo",
  "abstractKey": null
};
})();

(node as any).hash = "a12a827f9bc79e01d48927f08427746f";

export default node;
